import React from "react";
import { LocationsInfiniteLoader } from "./LocationsInfiniteLoader";

export interface LocationsMenuListProps {
  selectProps: {
    hasNextPage: boolean;
    isNextPageLoading: boolean;
    loadNextPage: () => null;
    itemSize: number;
    maxMenuHeight: number;
  };
  children: React.ReactChildren[];
}

export function LocationsMenuList({ children, selectProps }: LocationsMenuListProps) {
  return (
    <LocationsInfiniteLoader
      items={Array.isArray(children) ? children : [children]}
      hasNextPage={selectProps.hasNextPage}
      isNextPageLoading={selectProps.isNextPageLoading}
      loadNextPage={selectProps.loadNextPage}
      itemSize={selectProps.itemSize}
      maxMenuHeight={selectProps.maxMenuHeight}
    />
  );
}
